import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

export const SetAllButton = (props) => {
  const [inputValue, setInputValue] = useState('');
  function onInput(e) {
    setInputValue(e.target.value);
  }

  function clickButton(e) {
    props.selectedRegions.map((region) => {
      props.products.map((product, index) => {
        if ((props.name === 'minPrice' || props.name === 'maxPrice') && product[region].lockRegionPrices) {
          return;
        } else if (
          (props.name === 'minTargetMargin' || props.name === 'maxTargetMargin') &&
          product[region].lockRegionMargins
        ) {
          return;
        } else if (props.name === 'lockButton') {
          props.updateRegionalProductAttribute(e, region, index, 'empty');
        } else if (props.name === 'unlockButton'){
          props.updateRegionalProductAttribute(e, region, index, 'lockRegionPrices')
        }
        
        
        
        else {
          props.updateRegionalProductAttribute(e, region, index);
        }
      });
    });
  }

  return (
    <div>
      {!props.value && props.name !== 'lockButton' && props.name !== 'unlockButton' && props.name !== 'strategyId' && (
        <Form.Control onChange={(e) => onInput(e)}></Form.Control>
      )}
      {props.name === 'strategyId' && (
        <select name='strategyId' id='strategyId' onChange={(e) => onInput(e)}>
          <option value='1'>1</option>
          <option value='2'>2</option>
          <option value='3'>3</option>
          <option value='4'>4</option>
          <option value='5'>5</option>
          <option value='6'>6</option>
          <option value='7'>7</option>
          <option value='8'>8</option>
          <option value='9'>9</option>
          <option value='10'>10</option>
          <option value='11'>11</option>
          <option value='12'>12</option>
        </select>
      )}

      <Button variant='primary' name={props.name} value={props.value || inputValue} onClick={(e) => clickButton(e)}>
        {props.text}
      </Button>
    </div>
  );
};
